import type { CSSProperties, ReactNode } from 'react'
import './index.less'

interface CButtonProps {
  children: ReactNode
  onClick?: () => void
  shape?: 'pill' | 'soft'
  size?: 'md' | 'lg'
  arrow?: 'inline' | 'circle'
  htmlType?: 'button' | 'submit'
  className?: string
  style?: CSSProperties
}

const CButton = ({
  children,
  onClick,
  shape = 'pill',
  size = 'md',
  arrow,
  htmlType = 'button',
  className = '',
  style,
}: CButtonProps) => {
  const classNames = [
    'c-button',
    `c-button--${shape}`,
    `c-button--${size}`,
    arrow ? `c-button--arrow-${arrow}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button type={htmlType} className={classNames} onClick={onClick} style={style}>
      <span className="c-button__label">{children}</span>
      {arrow && <span className="c-button__arrow">→</span>}
    </button>
  )
}

export default CButton
